export const updateObject = (oldState, newState) => {
  return {
    ...oldState,
    ...newState
  };
};
